/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_LabelsInputs */

const cs_clients_create_labels = /** @type {(inputs: Clients_Create_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítky`)
};

const en_clients_create_labels = /** @type {(inputs: Clients_Create_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Clients_Create_LabelsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_create_labels = /** @type {((inputs?: Clients_Create_LabelsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_LabelsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_labels(inputs)
	return cs_clients_create_labels(inputs)
});